// Shared Action Cable consumer for app-level channels (Turbo has its own).
import { createConsumer } from "@rails/actioncable"

export default createConsumer()
